import { render } from "./Dropdown.vue?vue&type=template&id=4bfe6596"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"

import "./Dropdown.vue?vue&type=style&index=0&id=4bfe6596&lang=css"
script.render = render

export default script